import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useState } from "react";

import { openNotification } from "src/components/helpers/notification";
import { useEffect } from "react";
import { getClientsList } from "src/store/Slices/ClientsSlice";
import {
  downloadReportXlsx,
  buildBody,
  buildAdditionaldBody,
} from "src/components/helpers/downloadReport";
import { getReport } from "src/store/Slices/ClientsSlice";
import { UserAbonementReport } from "./ReportModalComponents/UserAbonementReport";
import { DefaultModalComponent } from "./ReportModalComponents/DefaultModalComponent";
import { GetClientsReport } from "./ReportModalComponents/GetClientsReport";
import { toBePartiallyChecked } from "@testing-library/jest-dom/matchers";

const ReportModal = ({
  commentModal,
  setCommentModal,
  reportInfo,
  setReportInfo,
}) => {
  const dateFormatList = ["DD.MM.YYYY"];
  // HELPERS
  const dispatch = useDispatch();
  dayjs.extend(customParseFormat);
  const reportData = useSelector((state) => state.ClientsSlice.reportData);
  const clubs = useSelector((state) => state.DropDownSlice.clubs);
  const monthsCount = useSelector((state) => state.DropDownSlice.months);

  const onClickGetReport = () => {
    let params = [];

    if (reportInfo.value === 2) {
      params = [
        {
          name: "reportRequest",
          value: {
            from: `${dayjs(fromDate).format("YYYY-MM-DD")}T10:00:00`,
            to: `${dayjs(toDate).format("YYYY-MM-DD")}T10:00:00`,
            clubId: clubId,
            monthCount: months,
            oneDayAbonements: oneDay,
            extensionAbonements: extension,
          },
        },
      ];
    } else if (reportInfo.value === 5) {
      params = [
        {
          name: "request",
          value: {
            birthdayFrom: birthdayFrom ? `${dayjs(birthdayFrom).format("YYYY-MM-DD")}T10:00:00`: null,
            birthdayTo: birthdayTo ? `${dayjs(birthdayTo).format("YYYY-MM-DD")}T10:00:00`:null,
            clubId: clubId,
            phoneNumber: phoneNumber,
            email: email,
            clientF: clientF,
            clientI: clientI,
            clientO: clientO,
            idFrom: idFrom,
            idTo: idTo,
          },
        },
      ];
    } else {
      params = [
        {
          name: "reportRequest",
          value: {
            from: `${dayjs(fromDate).format("YYYY-MM-DD")}T10:00:00`,
            clubId: clubId,
            monthCount: months,
            oneDayAbonements: oneDay,
            extensionAbonements: extension,
          },
        },
      ];
    }

    if (
      reportInfo.value === 2 &&
      (fromDate === undefined || toDate === undefined)
    ) {
      openNotification({
        type: "error",
        message: "Введите дату полностью",
      });
    } else if (reportInfo.value === 4 && fromDate === undefined) {
      openNotification({
        type: "error",
        message: "Введите дату",
      });
    } else {
      const body = buildAdditionaldBody(reportInfo.mnemo, params);
      dispatch(getReport(body)).then((value) => {
        downloadReportXlsx(value.payload);
        setReportInfo({ mnemo: "", value: null });
        setCommentModal(false);
      });
    }
  };

  // STATE
  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();
  const [clubId, setClubId] = useState(null);
  const [months, setMonths] = useState(null);
  const [oneDay, setOneDay] = useState(true);
  const [extension, setExtension] = useState(true);
  const [birthdayFrom, setBirthdayFrom] = useState(null);
  const [birthdayTo, setBirthdayTo] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [email, setEmail] = useState(null);
  const [clientF, setClientF] = useState(null);
  const [clientI, setClientI] = useState(null);
  const [clientO, setClientO] = useState(null);
  const [idFrom, setIdFrom] = useState(null);
  const [idTo, setIdTo] = useState(null);

  useEffect(() => {
    setFromDate();
    setToDate();
    setClubId(null);
    setMonths(null);
    setOneDay(true);
    setExtension(true);
  }, [commentModal]);
  switch (reportInfo.value) {
    case 2:
      return (
        <UserAbonementReport
          {...{
            commentModal,
            fromDate,
            toDate,
            clubId,
            months,
            oneDay,
            extension,
            setCommentModal,
            setFromDate,
            setToDate,
            setClubId,
            setMonths,
            setOneDay,
            setExtension,
            clubs,
            monthsCount,
            onClickGetReport,
          }}
        />
      );
      break;
    case 5:
      return (
        <GetClientsReport
          {...{
            birthdayFrom,
            birthdayTo,
            commentModal,
            clubId,
            phoneNumber,
            email,
            clientF,
            clientI,
            clientO,
            idFrom,
            idTo,
            setBirthdayFrom,
            setBirthdayTo,
            setCommentModal,
            setClubId,
            setPhoneNumber,
            setEmail,
            setClientF,
            setClientI,
            setClientO,
            setIdFrom,
            setIdTo,
            clubs,
            onClickGetReport,
          }}
        />
      );
      break;
    default:
      return (
        <DefaultModalComponent
          {...{
            commentModal,
            fromDate,
            clubId,
            months,
            oneDay,
            extension,
            setCommentModal,
            setFromDate,
            setClubId,
            setMonths,
            setOneDay,
            setExtension,
            clubs,
            monthsCount,
            onClickGetReport,
          }}
        />
      );
  }
};

export default ReportModal;
